var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronUpDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4007 5.70004C11.4007 5.86864 11.3365 6.03792 11.207 6.1671C10.9491 6.42508 10.5316 6.42508 10.2736 6.1671L5.70042 1.5936L1.12692 6.1671C0.868941 6.42508 0.451094 6.42508 0.193484 6.1671C-0.0644947 5.90912 -0.0644947 5.49127 0.193484 5.23335L5.23336 0.193474C5.49134 -0.0645048 5.90919 -0.0645048 6.1668 0.193474L11.207 5.23335C11.3362 5.3621 11.4007 5.53107 11.4007 5.70004Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25556e-05 10.5498C1.2563e-05 10.3812 0.0642306 10.212 0.193712 10.0828C0.451691 9.8248 0.869169 9.8248 1.12715 10.0828L5.70034 14.6563L10.2738 10.0828C10.5318 9.8248 10.9497 9.8248 11.2073 10.0828C11.4653 10.3408 11.4653 10.7586 11.2073 11.0165L6.16739 16.0564C5.90942 16.3144 5.49157 16.3144 5.23396 16.0564L0.193774 11.0165C0.0646001 10.8878 1.25482e-05 10.7188 1.25556e-05 10.5498Z",
    fill: "#667085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUpDown);
export default __webpack_public_path__ + "static/media/icon-chevron-up-down.1ccc7947e5e5e6347ab8824b872ebd7e.svg";
export { ForwardRef as ReactComponent };